import { Box, useColorModeValue } from '@chakra-ui/react';
import React from 'react';

interface TimelineLineProps {
  top: string;
  bottom: string;
  selectedRange?: [number, number];
  selectedTop?: number;
  selectedBottom?: number;
  isRangeSelected?: boolean;
}

export const TimelineLine: React.FC<TimelineLineProps> = ({
  top,
  bottom,
  selectedTop,
  selectedBottom,
  isRangeSelected = false,
}) => {
  const timelineColor = useColorModeValue('gray.400', 'gray.500');
  const selectedBorderColor = useColorModeValue('blue.500', 'blue.300');

  return (
    <>
      {/* Base timeline line (gray) */}
      <Box
        position="absolute"
        left="16px"
        top={top}
        bottom={bottom}
        width="1px"
        backgroundColor={timelineColor}
      />

      {/* Selected range line (blue) - only shown when a range is selected */}
      {isRangeSelected &&
        selectedTop !== undefined &&
        selectedBottom !== undefined && (
          <Box
            position="absolute"
            left="16px"
            top={`${selectedTop}px`}
            height={`${selectedBottom - selectedTop}px`}
            width="2px"
            backgroundColor={selectedBorderColor}
            zIndex={1}
          />
        )}
    </>
  );
};

export default TimelineLine;
